import { apiCall } from './gqlClient';
const GETBOOKEDEVENTS_QUERY = "\n  query getBookedEvents($startTime: DateTime, $endTime: DateTime, $email: String, $resourceId: Int, $entityType: String) {\n    getBookedEvents(startTime: $startTime, endTime: $endTime, email: $email, resourceId: $resourceId, entityType: $entityType)\n    {\n      id\n\t\t\tserviceId\n\t\t\tcreated\n\t\t\tname\n\t\t\temail\n\t\t\tstartTime\n\t\t\tendTime\n\t\t\ttype\n\t\t\tentityType\n\t\t\tstatus\n\t\t\tduration\n\t\t\tcapacity\n\t\t\ttotalCapacity\n\t\t\tclassId\n\t\t\tsubServiceId\n\t\t\tserviceName\n\t\t\tprice\n\t\t\tcollaboratorPercentPrice\n      ...fragments\n    }\n  }";
export const getBookedEventsApiCall = async function (_ref) {
  let {
    startTime,
    endTime,
    email,
    resourceId,
    entityType
  } = _ref;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: GETBOOKEDEVENTS_QUERY,
    variables: {
      startTime,
      endTime,
      email,
      resourceId,
      entityType
    },
    fragments
  });
};
const GETBOOKEDEVENTSBYPROVIDERIDFROMADMIN_QUERY = "\n  query getBookedEventsByProviderIdFromAdmin($providerId: Int!, $startTime: DateTime, $endTime: DateTime, $email: String, $resourceId: Int, $entityType: String) {\n    getBookedEventsByProviderIdFromAdmin(providerId: $providerId, startTime: $startTime, endTime: $endTime, email: $email, resourceId: $resourceId, entityType: $entityType)\n    {\n      id\n\t\t\tsubscriptionId\n\t\t\tuserId\n\t\t\tproviderId\n\t\t\tproviderName\n\t\t\tserviceId\n\t\t\tcreated\n\t\t\tname\n\t\t\tdescription\n\t\t\temail\n\t\t\tstartTime\n\t\t\tendTime\n\t\t\ttype\n\t\t\tentityType\n\t\t\tstatus\n\t\t\tcancelledBy\n\t\t\tcode\n\t\t\tduration\n\t\t\tcapacity\n\t\t\ttotalCapacity\n\t\t\tavailableCapacity\n\t\t\tminimumCapacity\n\t\t\tisSessionBought\n\t\t\tclassId\n\t\t\tsubServiceId\n\t\t\tcolor\n\t\t\tpricingModel\n\t\t\tprice\n\t\t\tpaidWithUserMembershipId\n\t\t\tpaid\n\t\t\twaitingListPosition\n\t\t\tlocationType\n\t\t\tserviceName\n\t\t\tserviceDescription\n\t\t\tnote\n\t\t\tpresence\n\t\t\torderId\n\t\t\tdisplayName\n\t\t\tpreparationTime\n\t\t\tcollaboratorPercentPrice\n\t\t\tpayment\n\t\t\ttimezone\n      ...fragments\n    }\n  }";
export const getBookedEventsByProviderIdFromAdminApiCall = async function (_ref2) {
  let {
    providerId,
    startTime,
    endTime,
    email,
    resourceId,
    entityType
  } = _ref2;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: GETBOOKEDEVENTSBYPROVIDERIDFROMADMIN_QUERY,
    variables: {
      providerId,
      startTime,
      endTime,
      email,
      resourceId,
      entityType
    },
    fragments
  });
};
const GETCALENDAREVENTS_QUERY = "\n  query getCalendarEvents($startTime: DateTime, $endTime: DateTime, $resourceId: Int) {\n    getCalendarEvents(startTime: $startTime, endTime: $endTime, resourceId: $resourceId)\n    {\n      id\n\t\t\tsubscriptionId\n\t\t\tuserId\n\t\t\tproviderId\n\t\t\tproviderName\n\t\t\tserviceId\n\t\t\tcreated\n\t\t\tname\n\t\t\tdescription\n\t\t\temail\n\t\t\tstartTime\n\t\t\tendTime\n\t\t\ttype\n\t\t\tentityType\n\t\t\tstatus\n\t\t\tcancelledBy\n\t\t\tcode\n\t\t\tduration\n\t\t\tcapacity\n\t\t\ttotalCapacity\n\t\t\tavailableCapacity\n\t\t\tminimumCapacity\n\t\t\tisSessionBought\n\t\t\tclassId\n\t\t\tsubServiceId\n\t\t\tcolor\n\t\t\tpricingModel\n\t\t\tprice\n\t\t\tpaidWithUserMembershipId\n\t\t\tpaid\n\t\t\twaitingListPosition\n\t\t\tlocationType\n\t\t\tserviceName\n\t\t\tserviceDescription\n\t\t\tnote\n\t\t\tpresence\n\t\t\torderId\n\t\t\tdisplayName\n\t\t\tpreparationTime\n\t\t\tcollaboratorPercentPrice\n\t\t\tpayment\n\t\t\ttimezone\n      ...fragments\n    }\n  }";
export const getCalendarEventsApiCall = async function (_ref3) {
  let {
    startTime,
    endTime,
    resourceId
  } = _ref3;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: GETCALENDAREVENTS_QUERY,
    variables: {
      startTime,
      endTime,
      resourceId
    },
    fragments
  });
};
const GETCUSTOMEREVENTS_QUERY = "\n  query getCustomerEvents($identifier: String, $startTime: DateTime, $endTime: DateTime, $customerId: Int, $isDeal: Boolean, $sortLatest: Boolean) {\n    getCustomerEvents(identifier: $identifier, startTime: $startTime, endTime: $endTime, customerId: $customerId, isDeal: $isDeal, sortLatest: $sortLatest)\n    {\n      id\n\t\t\tresourceId\n\t\t\townerId\n\t\t\townerIds\n\t\t\tname\n\t\t\tfirstname\n\t\t\tlastname\n\t\t\tfullname\n\t\t\tgender\n\t\t\tbirthday\n\t\t\taddress\n\t\t\tcity\n\t\t\tpostcode\n\t\t\tcountry\n\t\t\ttags\n\t\t\turl\n\t\t\tfacebook\n\t\t\tphone\n\t\t\temail\n\t\t\trole\n\t\t\tcode\n\t\t\tcodeExpiration\n\t\t\tactive\n\t\t\timage\n\t\t\tstatus\n\t\t\tproviderId\n\t\t\tprovidersIds\n\t\t\tuserLanguage\n\t\t\tblacklisted\n\t\t\tblockContent\n\t\t\tdescribedName\n\t\t\tnote\n\t\t\tcodiceFiscale\n\t\t\tpiva\n\t\t\tsdi\n\t\t\tcreated\n\t\t\tordersNumber\n\t\t\tcustomerId\n\t\t\tsvcGroupId\n\t\t\tgroupColor\n\t\t\tcompletedOnboarding\n\t\t\ttimezone\n      ...fragments\n    }\n  }";
export const getCustomerEventsApiCall = async function (_ref4) {
  let {
    identifier,
    startTime,
    endTime,
    customerId,
    isDeal,
    sortLatest
  } = _ref4;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: GETCUSTOMEREVENTS_QUERY,
    variables: {
      identifier,
      startTime,
      endTime,
      customerId,
      isDeal,
      sortLatest
    },
    fragments
  });
};
const GETCUSTOMEREVENTSFORWEBDEAL_QUERY = "\n  query getCustomerEventsForWebDeal($identifier: String, $startTime: DateTime, $endTime: DateTime, $customerId: Int, $isDeal: Boolean, $sortLatest: Boolean) {\n    getCustomerEventsForWebDeal(identifier: $identifier, startTime: $startTime, endTime: $endTime, customerId: $customerId, isDeal: $isDeal, sortLatest: $sortLatest)\n    {\n      id\n\t\t\tresourceId\n\t\t\townerId\n\t\t\townerIds\n\t\t\tname\n\t\t\tfirstname\n\t\t\tlastname\n\t\t\tfullname\n\t\t\tgender\n\t\t\tbirthday\n\t\t\taddress\n\t\t\tcity\n\t\t\tpostcode\n\t\t\tcountry\n\t\t\ttags\n\t\t\turl\n\t\t\tfacebook\n\t\t\tphone\n\t\t\temail\n\t\t\trole\n\t\t\tcode\n\t\t\tcodeExpiration\n\t\t\tactive\n\t\t\timage\n\t\t\tstatus\n\t\t\tproviderId\n\t\t\tprovidersIds\n\t\t\tuserLanguage\n\t\t\tblacklisted\n\t\t\tblockContent\n\t\t\tdescribedName\n\t\t\tnote\n\t\t\tcodiceFiscale\n\t\t\tpiva\n\t\t\tsdi\n\t\t\tcreated\n\t\t\tordersNumber\n\t\t\tcustomerId\n\t\t\tsvcGroupId\n\t\t\tgroupColor\n\t\t\tcompletedOnboarding\n\t\t\ttimezone\n      ...fragments\n    }\n  }";
export const getCustomerEventsForWebDealApiCall = async function (_ref5) {
  let {
    identifier,
    startTime,
    endTime,
    customerId,
    isDeal,
    sortLatest
  } = _ref5;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: GETCUSTOMEREVENTSFORWEBDEAL_QUERY,
    variables: {
      identifier,
      startTime,
      endTime,
      customerId,
      isDeal,
      sortLatest
    },
    fragments
  });
};
const GETMYBOOKEDEVENTS_QUERY = "\n  query getMyBookedEvents($startTime: DateTime) {\n    getMyBookedEvents(startTime: $startTime)\n    {\n      id\n\t\t\tsubscriptionId\n\t\t\tuserId\n\t\t\tproviderId\n\t\t\tproviderName\n\t\t\tserviceId\n\t\t\tcreated\n\t\t\tname\n\t\t\tdescription\n\t\t\temail\n\t\t\tstartTime\n\t\t\tendTime\n\t\t\ttype\n\t\t\tentityType\n\t\t\tstatus\n\t\t\tcancelledBy\n\t\t\tcode\n\t\t\tduration\n\t\t\tcapacity\n\t\t\ttotalCapacity\n\t\t\tavailableCapacity\n\t\t\tminimumCapacity\n\t\t\tisSessionBought\n\t\t\tclassId\n\t\t\tsubServiceId\n\t\t\tcolor\n\t\t\tpricingModel\n\t\t\tprice\n\t\t\tpaidWithUserMembershipId\n\t\t\tpaid\n\t\t\twaitingListPosition\n\t\t\tlocationType\n\t\t\tserviceName\n\t\t\tserviceDescription\n\t\t\tnote\n\t\t\tpresence\n\t\t\torderId\n\t\t\tdisplayName\n\t\t\tpreparationTime\n\t\t\tcollaboratorPercentPrice\n\t\t\tpayment\n\t\t\ttimezone\n      ...fragments\n    }\n  }";
export const getMyBookedEventsApiCall = async function (_ref6) {
  let {
    startTime
  } = _ref6;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: GETMYBOOKEDEVENTS_QUERY,
    variables: {
      startTime
    },
    fragments
  });
};
const GETWAITINGLISTITEMS_QUERY = "\n  query getWaitingListItems($sessionId: Int, $classId: Int, $startTime: DateTime) {\n    getWaitingListItems(sessionId: $sessionId, classId: $classId, startTime: $startTime)\n    {\n      subscriptionId\n\t\t\tsessionId\n\t\t\tproviderId\n\t\t\tstatus\n\t\t\ttotal\n\t\t\temail\n      ...fragments\n    }\n  }";
export const getWaitingListItemsApiCall = async function (_ref7) {
  let {
    sessionId,
    classId,
    startTime
  } = _ref7;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: GETWAITINGLISTITEMS_QUERY,
    variables: {
      sessionId,
      classId,
      startTime
    },
    fragments
  });
};
const GETAVAILABLEBOOKINGS_QUERY = "\n  query getAvailableBookings($providerId: Int!, $startTime: DateTime) {\n    getAvailableBookings(providerId: $providerId, startTime: $startTime)\n    {\n      id\n\t\t\tsubscriptionId\n\t\t\tuserId\n\t\t\tproviderId\n\t\t\tproviderName\n\t\t\tserviceId\n\t\t\tcreated\n\t\t\tname\n\t\t\tdescription\n\t\t\temail\n\t\t\tstartTime\n\t\t\tendTime\n\t\t\ttype\n\t\t\tentityType\n\t\t\tstatus\n\t\t\tcancelledBy\n\t\t\tcode\n\t\t\tduration\n\t\t\tcapacity\n\t\t\ttotalCapacity\n\t\t\tavailableCapacity\n\t\t\tminimumCapacity\n\t\t\tisSessionBought\n\t\t\tclassId\n\t\t\tsubServiceId\n\t\t\tcolor\n\t\t\tpricingModel\n\t\t\tprice\n\t\t\tpaidWithUserMembershipId\n\t\t\tpaid\n\t\t\twaitingListPosition\n\t\t\tlocationType\n\t\t\tserviceName\n\t\t\tserviceDescription\n\t\t\tnote\n\t\t\tpresence\n\t\t\torderId\n\t\t\tdisplayName\n\t\t\tpreparationTime\n\t\t\tcollaboratorPercentPrice\n\t\t\tpayment\n\t\t\ttimezone\n      ...fragments\n    }\n  }";
export const getAvailableBookingsApiCall = async function (_ref8) {
  let {
    providerId,
    startTime
  } = _ref8;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: GETAVAILABLEBOOKINGS_QUERY,
    variables: {
      providerId,
      startTime
    },
    fragments
  });
};
const GETMONTHLYAVAILABLEBOOKINGS_QUERY = "\n  query getMonthlyAvailableBookings($providerId: Int!, $startTime: DateTime, $entityType: Int) {\n    getMonthlyAvailableBookings(providerId: $providerId, startTime: $startTime, entityType: $entityType)\n    {\n      id\n\t\t\tsubscriptionId\n\t\t\tuserId\n\t\t\tproviderId\n\t\t\tproviderName\n\t\t\tserviceId\n\t\t\tcreated\n\t\t\tname\n\t\t\tdescription\n\t\t\temail\n\t\t\tstartTime\n\t\t\tendTime\n\t\t\ttype\n\t\t\tentityType\n\t\t\tstatus\n\t\t\tcancelledBy\n\t\t\tcode\n\t\t\tduration\n\t\t\tcapacity\n\t\t\ttotalCapacity\n\t\t\tavailableCapacity\n\t\t\tminimumCapacity\n\t\t\tisSessionBought\n\t\t\tclassId\n\t\t\tsubServiceId\n\t\t\tcolor\n\t\t\tpricingModel\n\t\t\tprice\n\t\t\tpaidWithUserMembershipId\n\t\t\tpaid\n\t\t\twaitingListPosition\n\t\t\tlocationType\n\t\t\tserviceName\n\t\t\tserviceDescription\n\t\t\tnote\n\t\t\tpresence\n\t\t\torderId\n\t\t\tdisplayName\n\t\t\tpreparationTime\n\t\t\tcollaboratorPercentPrice\n\t\t\tpayment\n\t\t\ttimezone\n      ...fragments\n    }\n  }";
export const getMonthlyAvailableBookingsApiCall = async function (_ref9) {
  let {
    providerId,
    startTime,
    entityType
  } = _ref9;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: GETMONTHLYAVAILABLEBOOKINGS_QUERY,
    variables: {
      providerId,
      startTime,
      entityType
    },
    fragments
  });
};
const GETUNIFIEDBOOKINGS_QUERY = "\n  query getUnifiedBookings($providerId: Int, $startTime: DateTime, $entityType: Int) {\n    getUnifiedBookings(providerId: $providerId, startTime: $startTime, entityType: $entityType)\n    {\n      id\n\t\t\tsubscriptionId\n\t\t\tuserId\n\t\t\tproviderId\n\t\t\tproviderName\n\t\t\tserviceId\n\t\t\tcreated\n\t\t\tname\n\t\t\tdescription\n\t\t\temail\n\t\t\tstartTime\n\t\t\tendTime\n\t\t\ttype\n\t\t\tentityType\n\t\t\tstatus\n\t\t\tcancelledBy\n\t\t\tcode\n\t\t\tduration\n\t\t\tcapacity\n\t\t\ttotalCapacity\n\t\t\tavailableCapacity\n\t\t\tminimumCapacity\n\t\t\tisSessionBought\n\t\t\tclassId\n\t\t\tsubServiceId\n\t\t\tcolor\n\t\t\tpricingModel\n\t\t\tprice\n\t\t\tpaidWithUserMembershipId\n\t\t\tpaid\n\t\t\twaitingListPosition\n\t\t\tlocationType\n\t\t\tserviceName\n\t\t\tserviceDescription\n\t\t\tnote\n\t\t\tpresence\n\t\t\torderId\n\t\t\tdisplayName\n\t\t\tpreparationTime\n\t\t\tcollaboratorPercentPrice\n\t\t\tpayment\n\t\t\ttimezone\n      ...fragments\n    }\n  }";
export const getUnifiedBookingsApiCall = async function (_ref0) {
  let {
    providerId,
    startTime,
    entityType
  } = _ref0;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: GETUNIFIEDBOOKINGS_QUERY,
    variables: {
      providerId,
      startTime,
      entityType
    },
    fragments
  });
};
const GETPROVIDERHOMEDETAILS_QUERY = "\n  query getProviderHomeDetails {\n    getProviderHomeDetails\n  }";
export const getProviderHomeDetailsApiCall = async () => apiCall({
  query: GETPROVIDERHOMEDETAILS_QUERY,
  variables: {}
});
const GETUSERSHOMEDETAILS_QUERY = "\n  query getUsersHomeDetails {\n    getUsersHomeDetails\n  }";
export const getUsersHomeDetailsApiCall = async () => apiCall({
  query: GETUSERSHOMEDETAILS_QUERY,
  variables: {}
});
const GETCALENDARHOLIDAYSANDPAUSES_QUERY = "\n  query getCalendarHolidaysAndPauses($selectedPeriod: DateTime!, $view: String!) {\n    getCalendarHolidaysAndPauses(selectedPeriod: $selectedPeriod, view: $view)\n    {\n      id\n\t\t\tname\n\t\t\tdescription\n\t\t\tstartTime\n\t\t\tendTime\n\t\t\tentityType\n\t\t\tcolor\n\t\t\tduration\n      ...fragments\n    }\n  }";
export const getCalendarHolidaysAndPausesApiCall = async function (_ref1) {
  let {
    selectedPeriod,
    view
  } = _ref1;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: GETCALENDARHOLIDAYSANDPAUSES_QUERY,
    variables: {
      selectedPeriod,
      view
    },
    fragments
  });
};